<div class="page-container">
    <section class="header">
        <section class="title-container">
            <h3 class="title">
                {{ "Contracts.ChangeStatus" | translate }}
            </h3>
            <hr class="separation-line" />
        </section>

        <span class="contracts-selected">{{selectedIds.length}} {{"Contracts.ContractsSelected" | translate}}</span>
    </section>

    <section class="details">
        @for (message of messages; track $index) {
            <p-message severity="error">{{message}}</p-message>
        }
        <div class="row-container" *ngFor="let claimType of selectedClaimTypes; let i = index">
            <div class="left-container">
                <label class="label">{{ "Contracts.ClaimType" | translate }}</label>
                <div>{{claimType.claimTypeDescription}}</div>
                <div class="extra-info">
                    <ng-container
                        *ngIf="claimType.selectedStatus && (claimType.selectedStatus.profileType || claimType.selectedStatus.statusCode || claimType.selectedStatus.smsCode || claimType.selectedStatus.initiateClosingFee == true)">
                        <p *ngIf="claimType.selectedStatus.profileType">
                            {{'Contracts.ChangeStatus_StartsProfile' | translate}}
                            {{claimType.selectedStatus.profileType}},
                            {{claimType.selectedStatus.profileText}}</p>
                        <p *ngIf="(claimType.selectedStatus.statusCode && isAnyContractWarned()) || updateStatusOnAllCasesIsActive()">
                            {{'Contracts.ChangeStatus_ChangesStatusOnCases' | translate}}
                            {{claimType.selectedStatus.statusCode}}, {{claimType.selectedStatus.statusText}}</p>
                        <p *ngIf="claimType.selectedStatus.smsCode">{{'Contracts.ChangeStatus_SendSms' |
                            translate}} {{claimType.selectedStatus.smsCode}},
                            {{claimType.selectedStatus.smsDescription}}</p>
                        <ng-container *ngIf="claimType.selectedStatus.initiateClosingFee == true">
                            <label>{{'Contracts.ChangeStatus.ChooseFee' | translate}}</label>
                            <ng-container *ngIf="claimType.closingFees; else simpleFee">
                                <p>
                                    <p-select [options]="claimType.closingFees" [(ngModel)]="selectedClosingFee"
                                        appendTo="body" name="closingFees" optionLabel="key">
                                    </p-select>
                                </p>
                            </ng-container>
                            <ng-template #simpleFee>
                                {{claimType.closingFeeText}}
                            </ng-template>
                        </ng-container>
                    </ng-container>
                </div>
            </div>
            <div class="right-container">
                <label class="label">{{ "Contracts.Status" | translate }}</label>
                <p-select [options]="claimType.statuses" [(ngModel)]="claimType.selectedStatus" name="status"
                    optionLabel="name" showClear="true" appendTo="body" id="{{'statusDropdown'+i}}"
                    (onChange)="onSelectStatus($event, claimType)" scrollHeight="250px"
                    placeholder="{{'General.Select' | translate}}" >
                    <ng-template let-item pTemplate="selectedItem">
                        <span>
                            {{isEnglish ? item.translationEn : item.translation}}
                        </span>
                    </ng-template>
                    <ng-template let-item pTemplate="item">
                        <span [class]="getClassForWorkListItem(item)">
                            {{isEnglish ? item.translationEn : item.translation}}
                        </span>
                    </ng-template>
                </p-select>
            </div>
        </div>
    </section>

    <section class="footer">
        <button class="button-basic" (click)="update()">{{'General.Update' | translate}}</button>
        <button class="button-red" (click)="cancel()">{{'General.Cancel' | translate}}</button>
    </section>
</div>